// The busy spinner for buttons (owner pick 2026-10-21, `design/button-spinner-mockup.html`:
// "Bars scale", busy look A = spinner + the busy label).
//
// "Bars scale" from svg-spinners by Utkarsh Verma
// (https://github.com/n3r4zzurr0/svg-spinners), MIT licence, CSS version.
//
// Inline, never an <img>: inline it takes the button's text colour
// (`currentColor`) and the global reduced-motion rule in globals.css reaches
// it, which stops the bars at equal height, a still mark beside the label.
// The animation lives ONCE in globals.css (`.et-spin-bar`), not in a <style>
// per instance. Mockup and the other candidates: design/button-spinner-mockup.html
// (kept as documentation, owner 2026-10-21).
// Sized in `em` so it follows the button's font size. Decorative: the label
// beside it says what is happening.

export function Spinner({ size = "1.15em", className = "" }: { size?: string; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={`shrink-0 ${className}`}
    >
      <rect className="et-spin-bar" x="1" y="6" width="2.8" height="12" />
      <rect className="et-spin-bar et-spin-b2" x="5.8" y="6" width="2.8" height="12" />
      <rect className="et-spin-bar et-spin-b3" x="10.6" y="6" width="2.8" height="12" />
      <rect className="et-spin-bar et-spin-b4" x="15.4" y="6" width="2.8" height="12" />
      <rect className="et-spin-bar et-spin-b5" x="20.2" y="6" width="2.8" height="12" />
    </svg>
  );
}

/**
 * A button's label with the spinner in front of it while `busy`. Wrap the
 * existing `{pending ? busyText : idleText}` in it. An inline-flex span, so it
 * centres the same inside a flex button or a block, text-centred one.
 */
export function BusyLabel({ busy, children }: { busy: boolean; children: React.ReactNode }) {
  return (
    // `align-top`: the spinner has no text baseline, so a baseline-aligned
    // inline-flex row sits on the svg's bottom edge and grew the button 3px
    // while busy (measured 46 -> 49px on the sign-in button).
    <span className="inline-flex items-center justify-center gap-8 align-top">
      {busy && <Spinner />}
      <span>{children}</span>
    </span>
  );
}
